import * as initMutations from './init'
import * as fileViewerMutations from './fileViewer'
import * as commonMutations from './common'
import * as progressMutations from 'js-core/store/mutations/progress'

export default {
    ...initMutations.default,
    ...fileViewerMutations.default,
    ...commonMutations.default,
    ...progressMutations.default
}
